/**
 * @module api-web:analyze
 */
import service from '@/service'

/**
 * 查询 财务- 应收账龄分析
 * @param {object} params
 */
export function getBillPeriodAnalysisList(params) {
  return service['api-web']({
    url: '/fin/ar/finSummary/getBillPeriodAnalysisList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
